import React, { useMemo } from 'react';
import ExpiryTimer from '../../shared/components/ExpiryTimer';
import { useCallState } from '../../shared/contexts/CallProvider';
import { useCallUI } from '../../shared/hooks/useCallUI';
import { Asides } from '../Asides';
import { Modals } from '../Modals';
import { Room } from '../Room';
import { Box, Stack } from '@mui/material';
import { theme } from '../../../../../common/styles/theme';
import { CALL_STATE_ENDED } from '../../shared/contexts/useCallMachine';

export const Call = ({ customComponentForState }: any) => {
	const { roomExp, state } = useCallState();

	const componentForState = useCallUI({
		state,
		room: <Room />,
		...customComponentForState,
	});

	return useMemo(
		() => (
			<Stack
				className={`call-container ${
					state === CALL_STATE_ENDED ? 'ended' : ''
				}`}
				flexDirection={'row'}
				justifyContent={'center'}
				alignItems={'center'}
				gap={1}
				sx={{
					flex: `1 1 100%`,
					width: 1,
					height: 1,
					overflowX: 'hidden',
					overflowY: 'auto',
					p: theme.spacing(1),

					'&.ended': {
						minHeight: 'min-content',
						my: theme.spacing(1),
					},

					'.aside-trancriptions': {
						flex: `1 1 400px`,
					}
				}}
			>
				{componentForState()}
				<Modals />
				<Asides />
			</Stack>
		),
		[componentForState, roomExp, state]
	);
};
